/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NotificationsRpc
 */

export const ConsentErrorTypename = 'com.hubspot.portals.platform.models.rpc.ConsentError';
export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const NotificationErrorTypename = 'com.hubspot.portals.platform.models.rpc.NotificationError';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorTypename = 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorTypename = 'com.hubspot.portals.platform.models.rpc.SettingsError';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorTypename = 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorTypename = 'com.hubspot.portals.platform.models.rpc.TrackEventError';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorTypename = 'com.hubspot.portals.platform.models.rpc.translations.TranslationsError';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const getNotificationsRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'getNotifications',
  auth: 'external',
  fingerprint: 'Rsw79Feu4ZbRjbBtHEnLIYBUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markNotificationAsReadRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'markNotificationAsRead',
  auth: 'external',
  fingerprint: 'x-2QffrKNOl8cyWpNBt5O4BUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markAllNotificationsAsReadRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'markAllNotificationsAsRead',
  auth: 'external',
  fingerprint: 'YlZ7t7iQQLdgJzATZQbQ-oBUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteNotificationRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NotificationsRpc',
  rpcName: 'deleteNotification',
  auth: 'external',
  fingerprint: 'dqP94nA66ZrqVVRLWEljJoBUhh7M2TJc',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};